/**
 * Default destination country for compliance recommendation lookups. Centralized
 * (rather than inlined) so supporting additional destination countries doesn't
 * require touching hook logic. See GL Slipway geo-expansion guidance.
 */
export const DEFAULT_DESTINATION_COUNTRY_CODE = 'US';
